import notSelectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox.svg";

const HeaderCheckbox = (props) => {
  return (
    <div className="header-checkbox-container">
      <img
        src={notSelectedCheckboxIcon}
        alt="checkbox"
        onClick={() => props.handleChange(true)}
      />
    </div>
  );
};

export default HeaderCheckbox;
